
  <div [class.ready-to-submit]="statusName == readyStatus" [class.text-cell]="statusName != readyStatus" (click)="submit()">
    <div [style.color]="statusColour">
      <span *ngIf="value == 15"><i class="material-icons grey">announcement</i></span>
      <span *ngIf="value != 15">{{statusName}}</span>
    </div>
  </div>
  